import { useLayoutEffect, useRef, useState } from "react";
import { LuClock3 } from "react-icons/lu";
import { ICall } from "../pages/home";

// A partir desse tanto de chamadas na lista, as linhas param de
// encolher e a lista passa a rolar (em vez de espremer o texto pra
// sempre).
const MAX_VISIBLE_CALLS = 12;

export default function Calls({ calls }: { calls: ICall[] }) {
  const isOverflowing = calls.length > MAX_VISIBLE_CALLS;
  const nameRefs = useRef<Array<HTMLSpanElement | null>>([]);
  const [wrappedRows, setWrappedRows] = useState<Set<number>>(new Set());

  // Roda a cada chamada nova, com ou sem rolagem: verifica quais
  // nomes ocuparam mais de uma linha, comparando a altura renderizada
  // do texto com a altura de uma única linha (font-size * line-height)
  // — se for bem maior que isso, quebrou. Checagem pontual só dessas
  // linhas, não um redesenho geral. Precisa rodar sempre (não só
  // acima de 12) porque o aperto já acontece antes disso, enquanto o
  // espaço ainda é dividido igualmente entre as chamadas.
  useLayoutEffect(() => {
    const next = new Set<number>();
    nameRefs.current.forEach((el, index) => {
      if (!el) return;

      const computed = getComputedStyle(el);
      const fontSize = parseFloat(computed.fontSize) || 16;
      const singleLineHeight =
        computed.lineHeight === "normal"
          ? fontSize * 1.2
          : parseFloat(computed.lineHeight) || fontSize * 1.2;

      if (el.getBoundingClientRect().height > singleLineHeight * 1.4) {
        next.add(index);
      }
    });
    setWrappedRows(next);
  }, [calls, isOverflowing]);

  return (
    <section className="painel-calls-card">
      <div className="painel-calls-header">
        <LuClock3 size={38} />
        Últimas chamadas
      </div>
      <ul className={`painel-calls-list ${isOverflowing ? "painel-calls-list--scroll" : ""}`}>
        {calls.map((call, index) => (
          <li
            key={index}
            className={wrappedRows.has(index) ? "painel-calls-list__row--wrapped" : ""}
          >
            <span className="painel-call-password">{call.password}</span>
            <span
              className="painel-call-name"
              ref={(el) => {
                nameRefs.current[index] = el;
              }}
            >
              {call.name}
            </span>
            <span className="painel-call-local">{call.local}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
